import { render, staticRenderFns } from "./aftersale_order_edit_travel.vue?vue&type=template&id=233a9d73&scoped=true"
import script from "./aftersale_order_edit_travel.vue?vue&type=script&lang=js"
export * from "./aftersale_order_edit_travel.vue?vue&type=script&lang=js"
import style0 from "./aftersale_order_edit_travel.vue?vue&type=style&index=0&id=233a9d73&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a9d73",
  null
  
)

export default component.exports